export const extractNumberFromString = txt => {
  let number = txt.match(/\d/g)
  number = number.join('')
  return parseInt(number)
}
